export default __webpack_public_path__ + "static/media/danji_cg_01.98feae53.jpg";